// extracted by mini-css-extract-plugin
export var chip = "_c8-0";
export var filterDropdown = "_c8-5";
export var filterItem = "_c8-6";
export var icon = "_c8-1";
export var removeButton = "_c8-3";
export var removeIcon = "_c8-4";
export var separator = "_c8-2";